export default String.raw`
{% assign name = include -%}
{% assign rc = [name] -%}
{% assign elementTranslation = name | Replace: '-', '_' -%}
{% assign rcLenght = rc.Products | Size -%}

{% if rcLenght > 0 -%}
    {% case rc.Type  -%}
        {% when 1 -%}
            {% assign title = translations.Rec_Promotion -%}
            {% assign link = 4 -%}
        {% when 2 -%}
            {% assign title = translations.Rec_NewProduct -%}
            {% assign link = 2 -%}
        {% when 3 -%}
            {% assign title = translations.Rec_MostViewed -%}
            {% assign link = false -%}
        {% when 4 -%}
            {% assign title = translations.Rec_TopSellers -%}
            {% assign link = false -%}
        {% when 5 -%}
            {% assign title = translations.Rec_CrossSeling -%}
            {% assign link = false -%}
        {% when 6 -%}
            {% assign title = translations.Rec_ProductFromNewsletter -%}
            {% assign link = 8 -%}
        {% when 7 -%}
            {% assign title = translations.Rec_RecomendedProducts -%}
            {% assign link = 16 -%}
        {% when 8 -%}
            {% assign title = translations.Rec_ProductSale -%}
            {% assign link = 32 -%}
        {% when 9 -%}
            {% assign title = translations.Rec_ProductExtraQuality -%}
            {% assign link = 64 -%}
        {% when 10 -%}
            {% assign title = translations.Rec_ProductExtraPrice -%}
            {% assign link = 128 -%}
        {% when 11 -%}
            {% assign title = translations.Rec_BestRated -%}
            {% assign link = 256 -%}
        {% when 12 -%}
            {% assign title = translations.Rec_ProductSellerRecommended -%}
            {% assign link = 512 -%}
        {% when 13 -%}
            {% assign title = translations.Rec_ProductAnnouncement -%}
            {% assign link = false -%}
        {% when 14 -%}
            {% assign title = translations.Rec_SuggestedProducts -%}
            {% assign link = false -%}
        {% when 15 -%}
            {% assign title = translations.Rec_Reward -%}
            {% assign link = 1024 -%}
        {% else -%}
            {% assign title = translations.Rec_RecomendedProducts -%}
            {% assign link = false -%}
    {% endcase -%}

    <section class="newsSection newsSection-js" data-name="{{ name }}" data-link="{{link}}">
        <div class="newsSection__header">
            <h2>
            {{ title }}
            </h2>
            {% if link -%}
                <a>
                    {{ translations.ShowAll }}
                    <svg><use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use></svg>
                </a>
            {% endif -%}
        </div>
        <div class="newsSection__container">
            <div class="newsSection__arrows">
                <div tabindex="0" role="button" aria-label="{{translations.PrevSlide}}" class="newsSection__arrows-prev arrow shadowed {{ name }}__prev">
                    <svg class="arrow__icon">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                    </svg>
                </div>
                <div tabindex="0" role="button" aria-label="{{translations.NextSlide}}" class="newsSection__arrows-next arrow shadowed {{ name }}__next">
                    <svg class="arrow__icon">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                    </svg>
                </div>
            </div>
            <div>
                <div class="newsSection__swiper {{ name }}">
                    <div class="swiper-wrapper newsSection__wrapper" data-len="{{ rcLenght }}">
                        {% for product in rc.Products -%}
                            <div class="swiper-slide newsSection__slide">
                                {% include 'partials/common/news-section-product.html' with product -%}
                            </div>
                        {% endfor -%}
                    </div>
                </div>
            </div>
        </div>
    </section>
{% endif -%}
`